// extracted by mini-css-extract-plugin
export var baseButton = "_om-0";
export var controlsArrowKeys = "_om-1";
export var controlsResetButton = "_om-2";
export var lightGameButton = "_om-4 _om-0";
export var playAgainButton = "_om-5 _om-0";
export var startGameButton = "_om-3 _om-0";